<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Floor`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM2.78667 4.99995C2.78669 3.89539 3.68211 2.99998 4.78667 2.99998L12.8519 2.99998L2.78653 13.083L2.78667 4.99995ZM2.78649 15.3602L2.78642 19.2652C2.78641 19.5075 2.82946 19.7396 2.90834 19.9545L8.32478 14.5285L5.98041 12.1606L2.78649 15.3602ZM4.06661 21.1318C4.28997 21.218 4.53267 21.2653 4.78642 21.2653H8.553L16.7978 13.0061L14.4975 10.6827L4.06661 21.1318ZM10.9236 21.2653L19.1823 21.2653C20.2869 21.2653 21.1823 20.3699 21.1823 19.2653L21.1825 10.9884L10.9236 21.2653ZM21.1825 8.61363L21.1826 5.00001C21.1826 4.70284 21.1178 4.4208 21.0015 4.16726L15.6828 9.49529L17.9831 11.8187L21.1825 8.61363ZM19.7513 3.082C19.5711 3.02863 19.3802 2.99998 19.1826 2.99998L15.1251 2.99998L7.16574 10.9732L9.51011 13.3411L19.7513 3.082Z"/></svg>
</template>
<script>

export default {
  name: 'IconFloor',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
